import { useState } from "react";

export default function useAddAccountBank() {
    const [showModalAddAccountBank, setShowModalAddAccountBank] = useState(false);

    return {
        showModalAddAccountBank,
        setShowModalAddAccountBank,
    };
}